import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { registerTokenGetter } from '@/services/ruutsApi/client'

// Must render INSIDE Auth0Provider. Bridges getAccessTokenSilently (a React
// hook product) into the module-scope axios interceptor.
export const ApiAuthBridge = () => {
  const { getAccessTokenSilently } = useAuth0()

  useEffect(() => {
    registerTokenGetter(getAccessTokenSilently)
  }, [getAccessTokenSilently])

  return null
}
